import { render } from "./ButtonOnlyWithIcon.vue?vue&type=template&id=7ef20e0e&scoped=true"
import script from "./ButtonOnlyWithIcon.vue?vue&type=script&lang=js"
export * from "./ButtonOnlyWithIcon.vue?vue&type=script&lang=js"

import "./ButtonOnlyWithIcon.vue?vue&type=style&index=0&id=7ef20e0e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef20e0e"]])

export default __exports__